import { useMemo } from 'react';
import { Cell, NonEditableCell } from '@silevis/reactgrid';
import { useTheme } from '@mui/material';
import usePlanTotals from './usePlanTotals';
import usePlanStore from '../../../../../../../../../../../store/planStore';
import { Dataset } from '../interfaces';
import addCell from '../helpers/addCell';

const useAddGrandTotal = (cells: Cell[]) => {
  const { countryForms, selectedCountry } = usePlanStore();
  const theme = useTheme();

  const stableRows = 3;
  const stableColumns = 2;

  const dataset: Dataset | undefined =
    countryForms[selectedCountry!]?.offline?.tv;

  const weeks = dataset?.grpTable?.weeks ?? [];

  const { planTotals } = usePlanTotals(weeks);
  const grandTotal = useMemo(() => {
    return planTotals.reduce((sum, value) => sum + value, 0);
  }, [planTotals]);

  addCell({
    cells,
    rowIndex: (weeks[0]?.copy.value.length ?? 0) + stableRows,
    colIndex: weeks.length + stableColumns,
    Template: NonEditableCell,
    value: grandTotal,
    colSpan: 2,
    sx: {
      background: theme.palette.grpTable.background.totals,
      color: theme.palette.grpTable.text.main,
      fontWeight: 700,
      fontSize: '14px',
    },
  });
};

export default useAddGrandTotal;
